import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface RoomCategory {
  id: number;
  name: string;
}

const fetchRoomCategories = async (): Promise<RoomCategory[]> => {
  try {
    const { data } = await api.get<RoomCategory[]>('/api/room-categories');
    return data;
  } catch (error) {
    throw new Error('Error al cargar categorías de habitación');
  }
};

export const useRoomCategories = () => {
  const { data: roomCategories = [], isLoading, error } = useQuery({
    queryKey: ['roomCategories'],
    queryFn: fetchRoomCategories,
  });

  return { roomCategories, isLoading, error };
}; 